module.exports = __webpack_public_path__ + "assets/img/pt-a965b00f.png";